@import 'fluid-rating.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';
@import '../../styles/mixins/fluid-transitions.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-rating {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @rating-tokens: @rating-tokens-legacy;
      @rating();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @rating-tokens: @rating-tokens-lm;
      @rating();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @rating-tokens: @rating-tokens-corp;
      @rating();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @rating-tokens: @rating-tokens-portal;
      @rating();
    }
  }
}


// ================================================================ //
// -- Component Detached Ruleset

@rating: {
  font-family: @font-family;
  font-size: @font-size;
  line-height: @line-height;
  color: @color-text;

  .form-group {
    .fluid-form-group();
  }

  .input-wrapper {
    .fluid-input(@rating-tokens);

    padding: @rating-tokens[padding];
    box-shadow: @rating-tokens[box-shadow];

    .cancel {
      position: absolute;
      right: 0.8em;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .rating-container {
    display: inline-flex;
    flex-direction: row;
    min-height: @form-field-height;

    &:not(.input-wrapper) {
      & ~ .form-element-notifications {
        padding-top: 0;
      }
    }
  }

  .rating-icon-container {
    outline: 0;
    line-height: 1;
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    cursor: pointer;

    &:hover {
      .svg-rating {
        transform: scale(1.4);
      }
    }
  }

  // Rating icon size

  .icon-size-sm {
    width: 1em;
    height: 1em;
  }

  .icon-size-md {
    width: 1.5em;
    height: 1.5em;
  }

  .icon-size-lg {
    width: 2em;
    height: 2em;
  }

  .icon-size-xl {
    width: 2.5em;
    height: 2.5em;
  }

  .svg-rating {
    transition: transform 300ms cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform-origin: 50% 50%;
  }

  .partial {
    width: 50%;
  }

  .empty {
    width: 0;
  }

  .fill {
    width: 100%;
  }
}
